// extracted by mini-css-extract-plugin
export var leftAlign = "_x-2";
export var popper = "_x-0";
export var subtitle = "_x-1";